"use strict";

exports.__esModule = true;
exports.default = void 0;
var _shallowProperty = _interopRequireDefault(require("./_shallowProperty.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal helper to obtain the `byteLength` property of an object.
var _default = exports.default = (0, _shallowProperty.default)('byteLength');